import React, { useEffect, useState } from 'react';
import notificationStyle from './notifications.module.css'
import { AvtarIcon, Dropdown, MarkReadIcon } from '../../svg';
import { useWebSocket } from '../../context/socketContext';
import { format, isToday, isYesterday, formatDistanceToNow } from 'date-fns';
import { Checkmark } from 'react-checkmark'
import { useDispatch, useSelector } from 'react-redux';
import { getNotification, markAllAsRead, markAsRead } from '../redux/notificationSlice';



const Notifications = () => {

    const dispatch = useDispatch()
    const { socket, isConnected } = useWebSocket()
    // const [notificationsData, setNotificationsData] = useState([]);
    // const notification = useSelector((state) => state.notification.notificationData);
    const user = useSelector((state) => state.user);
    const notifications = useSelector((state) => state.notification.notificationData)

    const formattedDate = (date = new Date()) => {
        const dateFromMongoDB = new Date(date);

        if (isToday(dateFromMongoDB)) {
            return `Today, ${format(dateFromMongoDB, 'hh:mm a')}`;
        } else if (isYesterday(dateFromMongoDB)) {
            return `Yesterday, ${format(dateFromMongoDB, 'hh:mm a')}`;
        } else {
            const differenceInDays = Math.floor((new Date() - dateFromMongoDB) / (1000 * 60 * 60 * 24));
            if (differenceInDays < 7) {
                return `${formatDistanceToNow(dateFromMongoDB)} ago`;
            } else {
                const formattedDate = format(dateFromMongoDB, 'dd MMM yyyy');
                const formattedTime = format(dateFromMongoDB, 'hh:mm a');
                return `${formattedDate}, ${formattedTime}`;
            }
        }
    }

    // useEffect(() => {
    //     if (socket && isConnected) {
    //         ws.onmessage = (event) => {
    //             const res = JSON.parse(event.data);
    //             const { type, data } = res;

    //             // if (type === "admin-notification") {
    //                 setNotificationsData((prev) => [data, ...prev]); 
    //             // }
    //         };
    //     }
    // }, [socket, isConnected]);

    // console.log(socket,isConnected,"ooommmbbbb");


    // useEffect(() => {
    //     if (socket && isConnected) {

    //         console.log("hy from notification");

    //         const handleNotification = (data) => {
    //             console.log(data,"sdffsfsfsfsdfsfsdfsfs");

    //             // setNotificationsData((prev) => 
    //                 // {
    //                 //     title: data.title || 'New Notification',
    //                 //     description: data.message || 'No details provided.',
    //                 //     timestamp: formattedDate(data.timestamp || new Date()),
    //                 // },
    //                 // ...prev,
    //                 setNotificationsData((prev) => [data, ...prev]); // Add new notification at the beginning



    //         };

    //         socket.on('notification', handleNotification);

    //         return () => {
    //             socket.off('notification', handleNotification);
    //         };
    //     }
    // }, [socket, isConnected]);

    const handleMark = async (data) => {
        try {
            console.log(data, "data");

            await dispatch(markAsRead(data))
            // await getNotification(user?.data?._id)

        } catch (error) {
            console.log(error.message);

        }
    }


    const handleMarkAll = () => {
        dispatch(markAllAsRead(user?.data?._id))
    }

    return (
        <div className={notificationStyle.notificationsContainer}>
            <div className={notificationStyle.notificationHeader}>
                <div className={notificationStyle.allNotify}>
                    {/* <h2>Notifications</h2> */}
                    {/* <span>All</span> */}
                    {/* <Dropdown /> */}
                </div>
                <div className={notificationStyle.headerOptions}>

                    <div className={notificationStyle.markReadButton} onClick={(e) => handleMarkAll()}>Mark all as read <MarkReadIcon /></div>
                </div>
            </div>
            <div className={notificationStyle.notificationList}>
                {notifications.map((notification, index) => (
                    // <div className={notificationStyle.notificationItem} onClick={handleMark(notification._id)}>
                    <div
                        key={notification._id} // Ensure each item has a unique key
                        className={notificationStyle.notificationItem}
                        onClick={() => handleMark(notification._id)} // Wrap function in an arrow function
                    >
                        <div className={notificationStyle.icon}>
                            <AvtarIcon />
                        </div>
                        <div className={notificationStyle.notificationContent}>
                            <h4 className={notificationStyle.notificationTitle}>{notification.notificationType}</h4>
                            <p className={notificationStyle.notificationDescription}>{notification.message}</p>
                            <span className={notificationStyle.notificationTimestamp}>{formattedDate(notification.createdAt)}</span>
                        </div>

                        {notification?.isRead && <div>
                            <MarkReadIcon /></div>}

                    </div>
                ))}
            </div>
        </div>
    )
}

export default Notifications